module.exports = __webpack_public_path__ + "static/img/PFIFFNER.beac9b95.png";